import { GraduationCap } from 'lucide-react';

import { Button } from '@sandtech-hub-monorepo/ui-kit';

import { CompletedProgram } from '../../../data/gsaEnrollments';

interface Props {
  program: CompletedProgram;
  onViewDetails: () => void;
}

/** A compact row for a completed ("past") program in the Learning page. */
export const PastProgramRow = ({ program, onViewDetails }: Props) => (
  <div className="flex flex-col gap-4 rounded-2xl border border-border-secondary bg-card p-6 sm:flex-row sm:items-center">
    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
      <GraduationCap className="h-6 w-6" />
    </div>

    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-3">
        <h3 className="text-base font-semibold text-heading">
          {program.title}
        </h3>
        <span className="rounded-md bg-saffron/10 px-2 py-0.5 text-xs font-medium text-saffron">
          {program.category}
        </span>
      </div>
      <p className="mt-1 text-sm text-muted-foreground">
        {program.description}
      </p>
    </div>

    <Button
      variant="outline"
      onClick={onViewDetails}
      className="shrink-0 rounded-full border-primary px-6 text-primary hover:bg-primary/5"
    >
      View details
    </Button>
  </div>
);
